import { RootState } from 'handlers';

export const getAiCoachConversation = (state: RootState) => state.aiCoachConversation;
